import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable()
export class PartnerAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'partner';

  public getPartners(search: string) {
    const request = 'getPartners';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const params = { search: search };

    return this._apiService.get<app.models.Partner[]>(url, params);
  }

  public getPartner(partnerId: string) {
    const request = 'getPartner';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const params = { partnerId: partnerId };

    return this._apiService.get<app.models.Partner>(url, params);
  }

  public getClient() {
    const request = 'getClient';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.Partner>(url);
  }

  public getCurrentPartnerProfileInfo() {
    const request = 'getCurrentPartnerProfileInfo';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.PartnerProfileModel>(url);
  }

  public getCompanyInfo() {
    const request = 'getCompanyInfo';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<app.models.CompanyInfoModel>>(url);
  }

  public getPartnerRequestCreationRestrictions() {
    const request = 'getPartnerRequestCreationRestrictions';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    return this._apiService.get<app.models.PartnerRequestCreationRestrictions>(url);
  }

  public getCurrentPartnerAdresses() {
    const request = 'getCurrentPartnerAddresses';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.AddressProfileModel[]>(url);
  }

  public getCurrentPartnerBankAccounts() {
    const request = 'getCurrentPartnerBankAccounts';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.BankAccountProfileModel[]>(url);
  }

  public getDealers() {
    const request = 'getDealers';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.PartnerCompany[]>(url);
  }

  public getManufacturers() {
    const request = 'getManufacturers';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.PartnerCompany[]>(url);
  }
}
